export const normalizeLocaleCode = (raw: string | null | undefined): string => {
  if (raw == null) {
    return "";
  }
  return raw.trim().toLowerCase();
};
